export function formatCatalogDeliveryDate(days: number): string {
  if (days <= 0) {
    return 'Сегодня';
  }

  if (days === 1) {
    return 'Завтра';
  }

  if (days === 2) {
    return 'Послезавтра';
  }

  return `Через ${days} ${formatRussianDayWord(days)}`;
}

function formatRussianDayWord(days: number): string {
  const absoluteDays = Math.abs(days);
  const lastTwoDigits = absoluteDays % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return 'дней';
  }

  const lastDigit = absoluteDays % 10;

  if (lastDigit === 1) {
    return 'день';
  }

  if (lastDigit >= 2 && lastDigit <= 4) {
    return 'дня';
  }

  return 'дней';
}
